// extracted by mini-css-extract-plugin
export var active = "_dz-2";
export var recordingDot = "_dz-1";
export var recordingIndicator = "_dz-0";